import posthog from 'posthog-js';
import Config from 'react-native-config';

export async function setupAnalytics() {
  const key = Config.POSTHOG_KEY;
  const host = Config.POSTHOG_HOST;
  if (!key || !host) return;
  try {
    // idempotent init; posthog-js ignores repeat inits with same key
    posthog.init(key, { api_host: host, capture_pageview: false });
  } catch (e) {
    // no-op
  }
}

export function trackEvent(event = '', params = {}) {
  try {
    if (!event) return;
    posthog.capture(event, params || {});
  } catch (e) {
    // no-op
  }
}
